module.exports = __webpack_public_path__ + "img/mentoring.c3b30d66.svg";